module.exports = __webpack_public_path__ + "img/img-5.266125da.png";